import { getRules } from 'utils/util'

const EVALUATE_LIST = [
  {
    label: '无特殊状况',
    value: 1,
  },
  {
    label: '延期款项未还清',
    value: 2,
  },
  {
    label: '逾期款项在最近一周内才刚刚还清',
    value: 3,
  },
  {
    label: '目前正在逾期',
    value: 4,
  },
  {
    label: '面临破产清算',
    value: 5,
  },
  {
    label: '出现重大税务风险或涉及法律诉讼',
    value: 6,
  },
  {
    label: '出现重大投资失败',
    value: 7,
  },
  {
    label: '管理人出现重大变化，危及正常业务运作',
    value: 8,
  },
  {
    label: '经审计（联想或外部审计）出现严重资不抵债',
    value: 9,
  },
  {
    label: '注册资金大幅减少',
    value: 10,
  },
  {
    label: '其他公认风险较高的情况',
    value: 11,
  },
]

const SUB_EVALUATE_LIST = [
  {
    value: 1,
    label: '能获得第一档现金点',
  },
  {
    value: 2,
    label: '能获得第二档现金点',
  },
  {
    value: 3,
    label: '肯定能在档期内收回',
  },
  {
    value: 4,
    label: '该短期申请超过标准账期',
  },
]

export const CREDIT_RISKING_SCHEMA = {
  companyCode: {
    label: '企业ID',
    type: 'input',
    disabled: true,
  },
  companyName: {
    label: '企业名称',
    type: 'input',
    disabled: true,
  },
  creditLevel: {
    label: '代理基本风险级别',
    type: 'input',
    disabled: true,
  },
  timeRisk: {
    label: '时点风险评价',
    type: 'select',
    optionList: EVALUATE_LIST,
    rules: getRules('请选择时点风险评价'),
  },
  currentStock: {
    label: '目前库存（台）',
    type: 'input',
    handleInputCheck: 'checkPositiveInt',
    rules: getRules('请输入目前库存台数'),
  },
  targetPurchase: {
    label: '目标进货额（台）',
    type: 'input',
    handleInputCheck: 'checkPositiveInt',
    rules: getRules('请输入目标进货额'),
  },
  weekAvgShipment: {
    label: '周平均出货（台）',
    type: 'input',
    handleInputCheck: 'checkPositiveInt',
    rules: getRules('请输入周平均出货台数'),
  },
  promotionWeek: {
    label: '促销时间（周）',
    type: 'input',
    handleInputCheck: 'checkPositiveInt',
    rules: getRules('请输入促销时间周数'),
  },
  currentStockWeek: {
    label: '目前库存周数（周）',
    type: 'input',
    handleInputCheck: 'checkPositiveInt',
    disabled: true,
  },
  planStockWeek: {
    label: '预计期末库存（周）',
    type: 'input',
    handleInputCheck: 'checkPositiveInt',
    disabled: true,
  },
  avgStockWeek: {
    label: '平均库存周转（周）',
    type: 'input',
    handleInputCheck: 'checkPositiveInt',
    disabled: true,
  },
  insuranceCoverageStr: {
    label: '保险覆盖率评价',
    type: 'input',
    disabled: true,
  },
  subjectiveEvaluation: {
    label: '主观评价',
    type: 'select',
    optionList: SUB_EVALUATE_LIST,
    rules: getRules('请选择主观评价'),
  },
}
